var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.972,
    height: 13.972,
    viewBox: "0 0 13.972 13.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tick-circle-svgrepo-com",
    d: "M8.986,2a6.986,6.986,0,1,0,6.986,6.986A7,7,0,0,0,8.986,2Zm3.339,5.379L8.364,11.34a.523.523,0,0,1-.741,0L5.647,9.363a.524.524,0,0,1,.741-.741L7.994,10.23l3.591-3.591a.524.524,0,0,1,.741.741Z",
    transform: "translate(-2 -2)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectDisableIcon);
export default __webpack_public_path__ + "static/media/correct-disable-icon.1f1ec7efb22dc9b8d81394be05ada523.svg";
export { ForwardRef as ReactComponent };